const mainNavEnabled = false;

export default [
    // {
    //     path: 'overview',
    //     name: 'Overview',
    //     redirect : "Overview",
    // },
    {
        path: 'overview',
        name: 'Overview',
        component: () => import( /* webpackChunkName: "limsds-overview" */ '../views/Overview.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },
    {
        path: 'submit-sample',
        name: 'Submit Sample',
        component: () => import( /* webpackChunkName: "limsds-submitsample" */ '../views/SubmitSample.vue'),
        meta: {
            mainNavEnabled: false,
        },
    }, {
        path: 'submit-sample-Sapphire',
        name: 'Submit Sample Sapphire',
        component: () => import( /* webpackChunkName: "limsds-submitsampleSapphire" */ '../views/SubmitSampleSapphire.vue'),
        meta: {
            mainNavEnabled: false,
        },
    }, {
        path: 'sample-arrival',
        name: 'Sample Arrival',
        component: () => import( /* webpackChunkName: "limsds-samplearrival" */ '../views/SampleArrival.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },{
        path: 'sample-points-arrival',
        name: 'Sample Points Arrival',
        component: () => import( /* webpackChunkName: "limsds-samplepointsarrival" */ '../views/SamplePointsArrival.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },{
        path: 'Preference',
        name: 'Preference',
        component: () => import( /* webpackChunkName: "limsds-preference" */ '../views/Preference.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },{
        path: 'Favorite',
        name: 'Favorite',
        component: () => import( /* webpackChunkName: "limsds-Favorite" */ '../views/Favorite.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },{
        path: 'Search-By-Sample',
        name: 'Search By Sample',
        component: () => import( /* webpackChunkName: "limsds-searchbysample" */ '../views/SearchBySample.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },{
        path: 'Search-By-Point',
        name: 'Search By Point',
        component: () => import( /* webpackChunkName: "limsds-searchbypoint" */ '../views/SearchByPoint.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },{
        path: 'Sample-Label-Print',
        name: 'Sample Label Print',
        component: () => import( /* webpackChunkName: "limsds-samplelabelprint" */ '../views/SampleLabelPrint.vue'),
        meta: {
            mainNavEnabled: false,
        },
    },{
        path: 'Report',
        name: 'Report',
        component: () => import( /* webpackChunkName: "limsds-report" */ '../views/ReportMenu.vue'),
        meta: {
            mainNavEnabled: false,
        },
        
    },{
        path: 'sample-Detail',
        name: 'Sample Detail',
        component: () => import( /* webpackChunkName: "limsds-sample-detail" */ '../views/sampleDetail.vue'),
        meta: {
            mainNavEnabled: false,
        },
        
    },{
        path: 'Transmission-Log',
        name: 'Transmission Log',
        component: () => import( /* webpackChunkName: "limsds-sample-detail" */ '../views/TransmissionLog.vue'),
        meta: {
            mainNavEnabled: false,
        },
        
    },

]
